import { AauthService } from 'src/app/services/aauth.service';
import { AlertService, MessageSeverity } from '@app/services/alert.service';
import { ClaimResultModel } from '@app/models/claims.model';
import { ClaimService } from '@app/feature-modules/claim/claim.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { DBkeys } from '@app/services/db-keys';
import { LocalStoreManager } from 'src/app/services/local-store-manager.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SignupResultModel } from '@app/models/register.model';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare function InitMyJs(): void;

@Component({
	selector: 'app-claim-verification',
	templateUrl: './claim-verification.component.html',
	styleUrls: ['./claim-verification.component.scss']
})
export class ClaimVerificationComponent implements OnInit, AfterViewInit {
	isLoading = true;
	bigtimeError = false;
	canContinue = false;
	professionalId = 0;
	claimResultModel = new ClaimResultModel(true, '');
	signupModel = new SignupResultModel();
	contactUsMetaData: string = null;

	constructor(
		private alertService: AlertService,
		private router: Router,
		public authService: AauthService,
		private configurations: ConfigurationService,
		private localStorage: LocalStoreManager,
		public claimService: ClaimService,
		private route: ActivatedRoute,
		private modalService: NgbModal
	) {

		this.route.queryParams.subscribe(async params => {
			const flyout = params.fly;
			if (flyout === '1') {
				this.claimService._isFlyout = true;
			}

			let corp = params.corp;
			const pId = params.pId;

			try {
				corp = parseInt(corp);
			} catch { }

			if (pId !== undefined && pId !== null) {
				this.localStorage.savePermanentData(pId, DBkeys.LOCAL_KEY_PID);
				this.localStorage.savePermanentData(corp, DBkeys.LOCAL_KEY_CORP);
				this.professionalId = pId;
				this.verifyClaim(pId);
			} else {
				this.bigtimeError = true;
			}
		});
	}

	ngOnInit(): void {
		this.claimService.claimStep = 1;
		try {
			InitMyJs();                                                                                                 // Init function.jss
		} catch (error) {
			console.error(error);
		}
	}

	ngAfterViewInit(): void { }

	formatContactUsMetaData(signup: SignupResultModel) {
		const msg = `Claim verification data - professional id: ${this.professionalId}, hasProfileToClaim: ${signup.hasProfileToClaim}, ` +
			`emailAlreadyInUse: ${signup.emailAlreadyInUse}, emailError: ${signup.emailError}, hasProfileToClaim: ${signup.hasProfileToClaim}, ` +
			`memberStatus: ${signup.memberStatus}, maskedEmail: ${signup.maskedEmail}, resultStatus: ${signup.resultStatus}.`;
		return msg;
	}

	verifyClaim(id: number) {
		return this.authService.claimVerification(id).subscribe(res => {
			this.signupModel = res;
			this.contactUsMetaData = this.formatContactUsMetaData(res);
			if (!this.signupModel.emailError) {
				if (!this.signupModel.emailAlreadyInUse) {
					this.canContinue = true;
				} else {
					this.canContinue = false;
				}
			} else {
				this.canContinue = false;
			}
			this.isLoading = false;
			return (!this.signupModel.emailError) ? { emailExists: true } : null;
		}),
			catchError(err => {
				console.log(err);
				this.isLoading = false;
				return of<any>([]);
			});
	}

	sendVerificationEmail() {
		this.isLoading = true;
		return this.authService.sendVerificationEmail(this.professionalId).subscribe(res => {
			this.claimService.claimStep = 2;
			this.claimResultModel = res;
			this.alertService.showMessage('Verificaton Sent', 'Your verification was sent! Please check your email for further details.', MessageSeverity.success);
			this.isLoading = false;
		}),
			catchError(err => {
				console.log(err);
				this.claimResultModel = new ClaimResultModel(false, err);
				this.isLoading = false;
				return of<any>([]);
			});
	}

	openContactUs(contactModal) {
		this.modalService.open(contactModal, { ariaLabelledBy: 'modal-basic-title' }).result.then(result => {
			this.modalService.dismissAll();
		});
	}

	openManualClaim(manualClaimModal) {
		this.isLoading = true;
		this.modalService.open(manualClaimModal, { ariaLabelledBy: 'modal-basic-title' }).result.then(result => {
			if (result) {
				// route to the confirmation page
				// TURN INTO COMPONENT!
				//
			}
			this.modalService.dismissAll();
			this.isLoading = false;
		});
	}

	closeEvent() {
		this.modalService.dismissAll();
	}
}

